import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { notItemImg } from '../../assets/images/product/prodImages';
import { SERVER_URL } from '../../config';
import sty from './ProdDetailPage.module.css';

const PrdDtlItem = ({ itemSeq, itemInfoName, itemPath, itemDivName, itemLinkSeq, itemSort, itemDiv2 }) => {

    const linkProps = itemSeq ? { to: `/product/list?list=${itemDiv2}&pageIdx=1&item=${itemLinkSeq}` } : { onClick: handleClick };

    function handleClick(e) {
        e.preventDefault();
    }

    return (
        <Link 
            key={`Dtlitem_${itemSeq}`} 
            className={itemSeq ? sty.itemDiv : sty.noneItem}
            {...linkProps}
        >
            <img className={sty.itemImg} src={itemSeq ? SERVER_URL + itemPath : notItemImg } alt={itemSeq ? itemSort : ""}/>
            <div className={`flex-column ${sty.itemDscr}`}>
                <span className={itemSeq ? `mb-10 ${sty.minLine}` : ""}></span>
                <span className='fw-500'>{itemDivName}</span>
                <span className='fw-300'>{itemInfoName}</span>
            </div>
        </Link>
    );
};

export default PrdDtlItem;